<div>
  <div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div>
  <div class="msTeam-modalBodyScroll" *ngIf="!loading">
    <div *ngIf=isShare style="padding-left: 15px; padding-right: 15px;">
      <sharesettings-dialog #shareSettingsDialog></sharesettings-dialog>
    </div>
    <mat-list role="list" *ngIf=!isShare>
      <div class="nodata"
        *ngIf="((siteCount==0 && folderCount == 0 && fileCount == 0)||(favourites | filter: searchText :['title','modifiedby','firstname','lastname','createdby']).length === 0) && selectionType==0 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">{{noFavourites}}</div>
      </div>

      <div class="nodata"
        *ngIf="((siteCount == 0)||(favourites | filter: searchText :['title','modifiedby','firstname','lastname','createdby']).length === 0) && selectionType==1 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">
          {{noFavouritesSites}}</div>
      </div>

      <div class="nodata"
        *ngIf="((folderCount == 0)||(favourites | filter: searchText :['title','modifiedby','firstname','lastname','createdby']).length === 0) && selectionType==2 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">{{noFavouritesFolders}}</div>
      </div>

      <div class="nodata"
         *ngIf="((fileCount == 0)||(favourites | filter: searchText :['title','modifiedby','firstname','lastname','createdby']).length === 0) && selectionType==3 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;"> 
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">{{noFavouritesFiles}}</div>
      </div>

      <mat-list-item
        *ngFor="let item of (favourites | filter: searchText :['title','modifiedby','firstname','lastname','createdby']); last as last"
        role="listitem">
        <mat-radio-button aria-label="Select {{item.extension}} {{item.newtype}} {{item.title}}" [value]="item"
          (change)="clickedRow($event.value)" (click)="clickedRow(item)">

          <div *ngIf="item.contenttype != 'Site'" class="float-left margTop5">
            <mat-icon matListIcon style="width:30px;">
              <!-- <div class="row"> -->
              <!-- <mat-radio-group [(ngModel)]="highlightRow" formControlName="radiooptions" > -->

              <!-- </mat-radio-group> -->
              <!-- <ng-template [ngIf]="item.contenttype == 'Site'">
              <img src="./assets/site_icon.svg" width="23">
            </ng-template> -->
              <!-- <ng-template [ngIf]="item.contenttype == 'Folder'">
              <img src="./assets/folder.png" width="23">
            </ng-template> -->
              <ng-template [ngIf]="item.contenttype == 'Folder'&& item.foldertype && item.foldertype=='SMART'"
                style="margin-bottom: 9px !important;">
                <img src="./assets/smart_folder_icon_new.svg" width="23">
              </ng-template>
              <ng-template [ngIf]="item.contenttype == 'Folder'&& item.foldertype && item.foldertype!='SMART'"
                style="margin-bottom: 9px !important;">
                <img src="./assets/folder.svg" width="23">
              </ng-template>

              <ng-template [ngIf]="item.contenttype == 'Document'">
                <img src="./assets/{{getFileIcon(item.extension)}}_icon.svg" width="23" />
              </ng-template>
              <!-- </div> -->
            </mat-icon>
          </div>
          <span *ngIf="item.contenttype != 'Document'" [ngStyle]="{'margin-top': item.contenttype != 'Site' ? '6px' : '0px'}" tabindex="0" matLine
            (keyup.enter)="openFolder(item,item.contenttype,item.contentid,item.contenttitle,item.httplink)"
            (click)="openFolder(item,item.contenttype,item.contentid,item.contenttitle,item.httplink)"role="link" 
            [attr.aria-label]="(item.contenttype == 'Site')? 'Open site ' +item.title:'Open folder ' +item.title">
            <ng-template [ngIf]="item.contenttype == 'Site'">
              <div class="siteIcon" style="margin-top: 9px;margin-left:5px;"></div>
            </ng-template>

              <!-- <span matLine matTooltip={{item.contenttitle}}
                [ngStyle]="{'margin-left': item.contenttype == 'Site' ? '37px' : '0px','margin-top': item.contenttype == 'Site' ? '4px' : '0px'}"
                [innerHTML]="item.contenttitle | highlight: searchText"></span> -->
              <span matLine matTooltip={{item.contenttitle}}
                [ngStyle]="{'margin-left': item.contenttype == 'Site' ? '37px' : '0px','margin-top': item.contenttype == 'Site' ? '4px' : '0px'}">{{item.contenttitle}}</span>

            <!-- <span matLine [ngStyle]="{'margin-left': item.contenttype == 'Site' ? '33px' : '0px' }">
            {{item.contenttitle}}
            <ng-template [ngIf]="item.contenttype == 'Document'">
              .{{item.extension}}
            </ng-template>
          </span> -->
              <div class="arrowIcon" style="margin-top: -8px;"></div>
            <span matLine class="mat-list-item-content-smaller"
              [ngStyle]="{'margin-left': item.contenttype == 'Site' ? '37px' : '0px' }">
              <span>Modified on </span>{{item.contentupdateddate}}
              <span *ngIf="item.modifiedby; else createdby">
                by {{item.modifiedby.firstname}} {{item.modifiedby.lastname}}
                <ng-template #createdby *ngIf="item.createdby.firstname; else noModified">
                  by {{item.createdby.firstname}} {{item.createdby.lastname}}
                </ng-template>
                <ng-template #noModified>
                </ng-template>
              </span>

              <!-- <ng-template *ngIf="item.modifiedby; else createdby">
              <span [innerHTML]="getText(item.modifiedby.firstname,item.modifiedby.lastname,false) | highlight: searchText"></span>
            </ng-template> -->

              <!-- <ng-template #createdby *ngIf="item.createdby.firstname; else noModified"> -->
              <!-- by {{item.createdby.firstname}} {{item.createdby.lastname}} -->
              <!-- <span
                [innerHTML]="getText(item.createdby.firstname,item.createdby.lastname,false) | highlight: searchText"></span> -->

              <!-- </ng-template>
            <ng-template #noModified>
            </ng-template> -->
            </span>
          </span>

          <span *ngIf="item.contenttype == 'Document'" style="margin-top: 6px;" matLine>
            <!-- <span matLine matTooltip={{item.contenttitle}}.{{item.extension}}
              [innerHTML]="getText(item.contenttitle,item.extension,true) | highlight: searchText"
              class="span2"></span> -->
            <span matLine matTooltip={{item.contenttitle}}.{{item.extension}}
              class="span2">{{item.contenttitle}}.{{item.extension}}</span>

          <!-- <span matLine [ngStyle]="{'margin-left': item.contenttype == 'Site' ? '33px' : '0px' }">
          {{item.contenttitle}}
          <ng-template [ngIf]="item.contenttype == 'Document'">
            .{{item.extension}}
          </ng-template>
        </span> -->
          <span matLine class="mat-list-item-content-smaller" style="margin-left: 0px;">
              {{item.contentsize| filesize}}
            <span>Modified on </span>{{item.contentupdateddate}}
            <span *ngIf="item.modifiedby; else createdby">
              by {{item.modifiedby.firstname}} {{item.modifiedby.lastname}}
              <ng-template #createdby *ngIf="item.createdby.firstname; else noModified">
                by {{item.createdby.firstname}} {{item.createdby.lastname}}
              </ng-template>
              <ng-template #noModified>
              </ng-template>
            </span>

            <!-- <ng-template *ngIf="item.modifiedby; else createdby">
            <span [innerHTML]="getText(item.modifiedby.firstname,item.modifiedby.lastname,false) | highlight: searchText"></span>
          </ng-template> -->

            <!-- <ng-template #createdby *ngIf="item.createdby.firstname; else noModified"> -->
            <!-- by {{item.createdby.firstname}} {{item.createdby.lastname}} -->
            <!-- <span
              [innerHTML]="getText(item.createdby.firstname,item.createdby.lastname,false) | highlight: searchText"></span> -->

            <!-- </ng-template>
          <ng-template #noModified>
          </ng-template> -->
          </span>
        </span>
        </mat-radio-button>
        <mat-divider [inset]="false" class="matlist-divider" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="msTeam-modal-footer" *ngIf=!isShare>
    <button *ngIf="isButtonVisible" type="button" mat-raised-button class="msTeam-btn full-width"
      (click)='loadMore(contenttype,true)'>
      {{loadingMessage}}
    </button>
  </div>

  <div class="global-footer add-divider" *ngIf="!isShare && !loading">
    <div style="padding-top: 10px;"></div>
    <div class="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading"></div>

    <div class="msTeam-modal-footer-right" *ngIf="!loading && !isShare" style="padding-top: 12px;">
      <button mat-raised-button (click)="closeDialog()" class="cancelBtn">Cancel</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled" style="margin-left:10px;"
        (click)="shareItem()" *ngIf="errorMsg.str.length ==0">
        {{sharebutton.sharetitle}}
      </button>

      <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled" style="margin-left:10px;"
        (click)="shareItem()" *ngIf="errorMsg.str.length >0">
        {{sharebutton.sharetitledefault}}
      </button>
    </div>
  </div>
</div>